import { getSettings } from '@hotjar/settings';
import { BASIC } from '@hotjar/webapp/domains/revenue/plan/feature-group';

import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import type { Entry } from 'type-fest';
import type { Feature } from './Feature';

/**
 * Get the minimum feature group required for the given feature, or null, if the given
 * feature is not available in any feature group.
 */
export const getMinimumFeatureGroupForFeature = (featureName: Feature): FeatureGroup => {
  const settings = getSettings();

  if (!settings) {
    throw new Error('Settings not loaded yet.');
  }

  if (!featureName) {
    throw new Error('Missing feature name.');
  }

  const featureGroupEntry = Object.entries(settings.plans)
    // Since its an un-ordered object, sort into ascending order as
    // defined by `tier`
    .sort(([, { tier: tier1 }], [, { tier: tier2 }]) => tier1 - tier2)
    // Find the first instance where the `features` string array includes `featureName`.
    .find(([, { features }]) => features.includes(featureName)) as Entry<typeof settings.plans>;

  if (featureGroupEntry === undefined) {
    return BASIC;
  }

  const featureGroupName = featureGroupEntry[0];

  return featureGroupName;
};
